import request from '../tools/request'

// 获取仓库节点
export function warehouseNode (body) {
  return request({
    url: '/api/basic/warehouse/warehouseNode',
    method: 'post',
    params: body
  })
}

// 获取仓库信息
export function warehouseInfo (body) {
  return request({
    url: '/api/basic/warehouse/warehouseInfo',
    method: 'post',
    params: body
  })
}

// 新增仓库
export function addWarehouse (body) {
  return request({
    url: '/api/basic/warehouse/addWarehouse',
    method: 'post',
    params: body
  })
}

// 新增楼号
export function addBuilding (body) {
  return request({
    url: '/api/basic/warehouse/addBuilding',
    method: 'post',
    params: body
  })
}

// 新增楼层
export function addFloor (body) {
  return request({
    url: '/api/basic/warehouse/addFloor',
    method: 'post',
    params: body
  })
}

// 新增分区
export function addWarearea (body) {
  return request({
    url: '/api/basic/warehouse/addWarearea',
    method: 'post',
    params: body
  })
}

// 新增垛位
export function addStack (body) {
  return request({
    url: '/api/basic/warehouse/addStack',
    method: 'post',
    params: body
  })
}

// 修改仓库
export function updateWarehouse (body) {
  return request({
    url: '/api/basic/warehouse/updateWarehouse',
    method: 'post',
    params: body
  })
}

// 修改楼号
export function updateBuilding (body) {
  return request({
    url: '/api/basic/warehouse/updateBuilding',
    method: 'post',
    params: body
  })
}

// 修改楼层
export function updateFloor (body) {
  return request({
    url: '/api/basic/warehouse/updateFloor',
    method: 'post',
    params: body
  })
}

// 修改分区
export function updateWarearea (body) {
  return request({
    url: '/api/basic/warehouse/updateWarearea',
    method: 'post',
    params: body
  })
}

// 修改垛位
export function updateStack (body) {
  return request({
    url: '/api/basic/warehouse/updateStack',
    method: 'post',
    params: body
  })
}

// 获取垛位列表
export function stackPageList (body) {
  return request({
    url: '/api/basic/warehouse/stackPageList',
    method: 'post',
    params: body
  })
}

// 删除仓库
export function delWarehouse (body) {
  return request({
    url: '/api/basic/warehouse/del',
    method: 'delete',
    params: body
  })
}

// 删除设备单个
export function delEquipment (body) {
  return request({
    url: '/api/maintain/equipment/del',
    method: 'delete',
    params: body
  })
}

// 根据设备ID集合批量删除设备，以,隔开
export function bathDelEquipment (body) {
  return request({
    url: '/api/maintain/equipment/bathDelEquipment',
    method: 'delete',
    params: body
  })
}

// 新增设备
export function addEquipment (body) {
  return request({
    url: '/api/maintain/equipment/add',
    method: 'post',
    params: body
  })
}

// 查询设备
export function queryEquipment (body) {
  return request({
    url: '/api/maintain/equipment/queryEquipment',
    method: 'post',
    params: body
  })
}

// 修改设备
export function updateEquipment (body) {
  return request({
    url: '/api/maintain/equipment/update',
    method: 'post',
    data: body
  })
}

// 设备详情
export function detailEquipment (body) {
  return request({
    url: '/api/maintain/equipment/detail',
    method: 'post',
    params: body
  })
}

// 更新设备状态
export function updateStatus (body) {
  return request({
    url: '/api/maintain/equipment/updateStatus',
    method: 'post',
    params: body
  })
}

// 查看日志
export function queryNodeHistoryInfo (body) {
  return request({
    url: '/api/basic/log/queryNodeHistoryInfo',
    method: 'post',
    params: body
  })
}

// 物料批量导入
export function batchImport (body) {
  return request({
    url: '/api/basic/material/batchImport',
    method: 'post',
    data: body
  })
}

// 获取物料列表
export function materialPage (body) {
  return request({
    url: '/api/basic/material/materialPage',
    method: 'post',
    params: body
  })
}

// 删除物料
export function delMaterial (body) {
  return request({
    url: '/api/basic/material/del',
    method: 'delete',
    params: body
  })
}

// 根据物料主键ID集合批量删除物料信息，以,隔开
export function bathDelMaterial (body) {
  return request({
    url: '/api/basic/material/bathDelMaterial',
    method: 'delete',
    params: body
  })
}

// 根据主键ID获取物料信息
export function materialDetail (body) {
  return request({
    url: '/api/basic/material/materialDetail',
    method: 'post',
    params: body
  })
}

// 修改物料信息
export function materialUpdate (body) {
  return request({
    url: '/api/basic/material/update',
    method: 'post',
    data: body
  })
}

// 根据物料代码获取物料列表
export function materialList (body) {
  return request({
    url: '/api/basic/material/materialList',
    method: 'post',
    params: body
  })
}

// 校验批次号（根据批次号模糊查询返回批次号和烟叶简称列表）
export function vaildMaterialBath (body) {
  return request({
    url: '/api/basic/material/vaildMaterialBath',
    method: 'post',
    data: body
  })
}

// 数据报表
export function searchDataReport (body) {
  return request({
    url: '/api/report/searchDataReport',
    method: 'post',
    params: body
  })
}

// 数据报表-垛位中传感器类型数量统计
export function searchNodeTypeCount (body) {
  return request({
    url: '/api/report/searchNodeTypeCount',
    method: 'post',
    params: body
  })
}

// 首页-首页不传参当月各类统计
export function searchHomePageCount (body) {
  return request({
    url: '/api/homepage/data/searchHomePageCount',
    method: 'post',
    params: body
  })
}

// 首页-首页养护阶段统计
export function searchMaintainStage (body) {
  return request({
    url: '/api/homepage/data/searchMaintainStage',
    method: 'post',
    params: body
  })
}

// 首页-首页月预警数量统计
export function searchMonthWarningCount (body) {
  return request({
    url: '/api/homepage/data/searchMonthWarningCount',
    method: 'post',
    params: body
  })
}

// 首页-首页垛位曲线数据
export function searchStackCurveData (body) {
  return request({
    url: '/api/homepage/data/searchStackCurveData',
    method: 'post',
    params: body
  })
}

// 首页-首页仓库温湿度
export function searchWarehouseTempMoist (body) {
  return request({
    url: '/api/homepage/data/searchWarehouseTempMoist',
    method: 'post',
    params: body
  })
}
// 历史数据报表
export function queryHistoryData (body) {
  return request({
    url: '/api/history/report/searchHistoryDataReport',
    method: 'post',
    params: body
  })
}



// WEBPACK FOOTER //
// ./src/api/basic.js